export const hectoClientKey = 'ST2406281447244788326'; 
